// IND-038: ventana del botón «N avisos» de la vista Desperdicio. Lista común de
// la página: cada aviso con mes lleva «Corregir <mes>».
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

import { MONTH_NAMES } from '../utils/wasteControl';
import type { WasteNotice } from '../utils/wasteControl';

const MUTED = '#94a3b8';

export default function IndustrialCostWasteNoticesDialog({
  open,
  onClose,
  year,
  notices,
  onFix,
}: {
  open: boolean;
  onClose: () => void;
  year: number;
  notices: WasteNotice[];
  onFix: (month: number) => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 900 }}>{`Avisos de desperdicio · ${year}`}</DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ color: MUTED, fontSize: 13, mb: 1.25 }}>
          El total de EPDM es el dato bueno; las líneas de un mes que no cuadra no cuentan en los cálculos por línea.
        </Typography>
        <Stack spacing={1}>
          {notices.map((notice) => (
            <Stack
              key={notice.key}
              direction="row"
              spacing={1.5}
              alignItems="center"
              justifyContent="space-between"
              sx={{ p: 1.25, borderRadius: 2, bgcolor: 'rgba(251,191,36,0.06)', border: '1px solid rgba(251,191,36,0.3)' }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 800, fontSize: 14, color: '#fde68a' }}>{notice.title}</Typography>
                <Typography sx={{ fontSize: 13, color: '#cbd5e1', fontVariantNumeric: 'tabular-nums' }}>{notice.detail}</Typography>
              </Box>
              {notice.month !== null ? (
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => onFix(notice.month as number)}
                  sx={{ textTransform: 'none', whiteSpace: 'nowrap', flexShrink: 0 }}
                >
                  {`Corregir ${MONTH_NAMES[notice.month - 1].toLowerCase()}`}
                </Button>
              ) : null}
            </Stack>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none', fontWeight: 800 }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
